import { Component, createSignal, For, onMount, Show } from "solid-js";
import { Artist } from "../../library/types";
import slugify from "slugify"
import { CMS } from "../cms/cms";
import { loadCms } from "../../App";
import { createStore } from "solid-js/store";

type State = {
    isContentReady: boolean;
}

export const BirthsDeaths: Component = () => {
    const [births, setBirths] = createSignal<Artist[]>([]);
    const [deaths, setDeaths] = createSignal<Artist[]>([]);
    const [state, setState] = createStore<State>(
        { isContentReady: false }
    );
    const load = async () => {
        const res = await fetch("/Home/GetBirthsAndDeathsJson");
        const json = await res.json();
        if (!json.Success) {
            return;
        }
        const data = json.Data;
        setBirths(data.Births);
        setDeaths(data.Deaths);
    };
    onMount(async() => {
        await loadCms([
            "homepage::heading/born-on-this-day",
            "homepage::heading/died-on-this-day"
        ]);
        await load();
        setState("isContentReady", true);
    });
    return (    
        <Show when={state.isContentReady}>
            <div style="background-color: #efefef; padding: 10px 10px; border-radius: 10px; margin-bottom: 10px;">
                <Show when={births().length > 0}>
                    <h4>
                        <CMS id="homepage::heading/born-on-this-day">Born on this day</CMS>
                    </h4>
                    <ul>
                        <For each={births()}>
                            {(artist) => (
                                <li>
                                    <a href={`/artists/${slugify(artist.Name)}/${artist.Id}`}>{artist.Name}</a> ({artist.BirthYear}&mdash;{artist.DeathYear})
                                </li>
                            )}
                        </For>
                    </ul>
                </Show>
                <Show when={deaths().length > 0}>
                    <h4>
                        <CMS id="homepage::heading/died-on-this-day">Died on this day</CMS>
                    </h4>
                    <ul>
                        <For each={deaths()}>
                            {(artist) => (
                                <li>
                                    <a href={`/artists/${slugify(artist.Name)}/${artist.Id}`}>{artist.Name}</a> ({artist.BirthYear}&mdash;{artist.DeathYear})
                                </li>
                            )}
                        </For>
                    </ul>
                </Show>
            </div>
        </Show>
    )
}